module.exports = __webpack_public_path__ + "static/img/szafa_15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_15.jpg
// module id = 9vVR
// module chunks = 0